/*
 * DAW · Drop verrouillé
 * Compte à rebours, bascule automatique des phases et déverrouillage par code.
 *
 * Le code d'accès n'est jamais présent dans la page : on compare l'empreinte
 * SHA-256 saisie par le visiteur à celle publiée par Liquid (data-hash), et
 * cette empreinte n'est publiée que pendant la fenêtre d'accès privilégié.
 *
 * Règle tenue ici : AUCUN texte visible n'est écrit dans ce fichier. Les phrases
 * que le script affiche viennent d'attributs posés par Liquid, donc réglables
 * dans l'éditeur de thème. Les valeurs de repli ne servent que si l'attribut
 * manque — elles ne doivent jamais devenir la source de vérité.
 */
(function () {
  'use strict';

  var COOKIE = 'daw_drop_key';
  var RELOAD_KEY = 'dawDropReloads';

  function toHex(buffer) {
    return Array.prototype.map
      .call(new Uint8Array(buffer), function (b) {
        return ('00' + b.toString(16)).slice(-2);
      })
      .join('');
  }

  function sha256(text) {
    if (!window.crypto || !window.crypto.subtle || !window.TextEncoder) {
      return Promise.reject(new Error('crypto indisponible'));
    }
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(toHex);
  }

  function readCookie() {
    var m = document.cookie.match(/(?:^|;\s*)daw_drop_key=([^;]+)/);
    return m ? m[1] : '';
  }

  function writeCookie(value, expiresAtMs) {
    var seconds = Math.max(60, Math.round((expiresAtMs - Date.now()) / 1000));
    document.cookie = COOKIE + '=' + value + '; path=/; max-age=' + seconds + '; SameSite=Lax';
  }

  /* Garde-fou : jamais plus de 3 rechargements automatiques par minute,
     pour éviter toute boucle si l'horloge du visiteur est très décalée. */
  function canReload() {
    try {
      var now = Date.now();
      var list = JSON.parse(sessionStorage.getItem(RELOAD_KEY) || '[]').filter(function (t) {
        return now - t < 60000;
      });
      if (list.length >= 3) return false;
      list.push(now);
      sessionStorage.setItem(RELOAD_KEY, JSON.stringify(list));
      return true;
    } catch (e) {
      return true;
    }
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init(panel) {
    var serverNow = parseInt(panel.getAttribute('data-now'), 10) * 1000;
    var vipAt = parseInt(panel.getAttribute('data-vip'), 10) * 1000;
    var dropAt = parseInt(panel.getAttribute('data-drop'), 10) * 1000;
    var state = panel.getAttribute('data-state');
    var expected = panel.getAttribute('data-hash') || '';
    var salt = panel.getAttribute('data-salt') || '';

    if (!dropAt) return;

    /* On se cale sur l'heure du serveur : l'horloge du visiteur peut être fausse. */
    var skew = Date.now() - serverNow;
    function now() {
      return Date.now() - skew;
    }

    var label = panel.querySelector('[data-daw-label]');
    var daysEl = panel.querySelector('[data-daw-days]');
    var hoursEl = panel.querySelector('[data-daw-hours]');
    var minutesEl = panel.querySelector('[data-daw-minutes]');
    var secondsEl = panel.querySelector('[data-daw-seconds]');

    /* La phrase de la fenêtre d'accès anticipé vient de l'éditeur, pas d'ici. */
    var vipLabel = label
      ? label.getAttribute('data-vip-label') ||
        'Accès privilégié ouvert — disponible pour tous dans …'
      : '';
    var vipLabelDone = false;

    function render() {
      var remaining = Math.max(0, dropAt - now());
      var total = Math.floor(remaining / 1000);
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var minutes = Math.floor((total % 3600) / 60);
      var seconds = total % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      /* On n'écrit la phrase qu'une fois : la réécrire chaque seconde ferait
         bafouiller les lecteurs d'écran. */
      if (label && !vipLabelDone && now() >= vipAt && now() < dropAt) {
        label.textContent = vipLabel;
        vipLabelDone = true;
      }

      /* Passage d'une phase à l'autre : on recharge pour que le serveur
         renvoie l'état à jour (formulaire de code, boutons d'achat, stock). */
      if (state === 'locked' && now() >= vipAt) {
        if (canReload()) window.location.reload();
        return;
      }
      if (state !== 'open' && now() >= dropAt) {
        if (canReload()) window.location.reload();
      }
    }

    render();
    setInterval(render, 1000);

    /* Déverrouillage par code */
    var form = panel.querySelector('[data-daw-form]');
    if (!form) return;

    var input = panel.querySelector('[data-daw-input]');
    var error = panel.querySelector('[data-daw-error]');
    var errorDefault = error ? error.textContent : '';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!expected) return;

      var value = (input && input.value ? input.value : '').trim().toLowerCase();
      if (!value) return;

      if (error) error.hidden = true;

      sha256(salt + '|' + value)
        .then(function (digest) {
          if (digest === expected) {
            writeCookie(digest, dropAt + 6 * 3600 * 1000);
            document.documentElement.classList.add('daw-drop-unlocked');
            window.location.reload();
          } else if (error) {
            error.textContent = errorDefault;
            error.hidden = false;
          }
        })
        .catch(function () {
          if (error) {
            error.textContent =
              error.getAttribute('data-crypto-error') ||
              'Votre navigateur ne permet pas la vérification du code. Essayez un autre navigateur.';
            error.hidden = false;
          }
        });
    });

    /* Cookie déjà présent et valide : on déverrouille sans rien demander. */
    if (expected && readCookie() === expected) {
      document.documentElement.classList.add('daw-drop-unlocked');
    }
  }

  function boot() {
    var panels = document.querySelectorAll('[data-daw-drop]');
    for (var i = 0; i < panels.length; i++) init(panels[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
